import script from "./site-joining.vue?vue&type=script&lang=ts&setup=true"
export * from "./site-joining.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__